import { render } from "./declinedModalOthers.vue?vue&type=template&id=898544d6"
import script from "./declinedModalOthers.vue?vue&type=script&lang=js"
export * from "./declinedModalOthers.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__